/**
 * session-look.ts — where a session stands for the student, and how their
 * screens say it: live now, upcoming, completed, missed or cancelled, each its
 * words and its tone, from one table. The sessions page's cards draw it as a
 * pill; a gameplay activity's page says it in its status line, which printed
 * the server's own word ("RUNNING") in every language.
 */
import type { PillTone } from '../../components/pill';

import type { SessionShown } from '../../api/student/session-attendance';

/**
 * Each standing's tone and words, a key written whole, so one the screens can
 * say has both or the build fails. `missed` is deliberately not `danger`:
 * `live` owns the red, and two states that always render alike are a bug. A
 * cancelled session wears the missed one's amber. The words are singular and
 * agree with one session (es Próxima, Perdida); the sessions page's tabs keep
 * their plurals.
 */
export const SESSION_LOOK: Record<SessionShown, { tone: PillTone; key: string }> = {
  live: { tone: 'danger', key: 'student.sessions.liveNow' },
  upcoming: { tone: 'brand', key: 'student.sessions.card.upcoming' },
  completed: { tone: 'success', key: 'student.sessions.card.completed' },
  missed: { tone: 'warning', key: 'student.sessions.card.missed' },
  cancelled: { tone: 'warning', key: 'student.sessions.card.cancelled' },
};
